import { useEffect } from "react";

import usePracticeSession from "./usePracticeSession";
import useLearningStrength from "./useLearningStrength";
import useProgressReport from "./useProgressReport";
import useTimeOnPractice from "./useTimeOnPractice";
import useQuestionStatus from "./useQuestionStatus";
import useQuestionStatusPie from "./useQuestionStatusPie";
import useDifficultyReport from "./useDifficultyReport";
import useCognitiveReport from "./useCognitiveReport";

const convertObjToQuery = (object) => {
  let query = "";
  if (object.subjectId) query += `&subject=${object.subjectId}`;
  if (object.chapterId) query += `&chapter=${object.chapterId}`;
  if (object.topicId) query += `&topic=${object.topicId}`;
  return query;
};

export default function useAssessmentAnalytics({
  sectionId,
  userId,
  filterData,
}) {
  const practice = usePracticeSession();
  const learning = useLearningStrength();
  const progress = useProgressReport();
  const time = useTimeOnPractice();
  const status = useQuestionStatus();
  const statusPie = useQuestionStatusPie();
  const difficulty = useDifficultyReport();
  const cognitive = useCognitiveReport();

  const loadAnalytics = async () => {
    const q = convertObjToQuery(filterData);
    const base = `${process.env.REACT_APP_ORIGIN2}/api/v1/students/practiceanalytics/sections/${sectionId}`;

    await practice.fetchData(`${base}/practicesessiondetails?student=${userId}${q}`);
    await learning.fetchData(`${base}/questionlearningstatus?student=${userId}${q}`);
    await progress.fetchData(`${base}/questioncompletestatus?student=${userId}${q}`);
    await statusPie.fetchData(`${base}/questionAttemptStatus?overall=true${q}`);
    // await time.fetchData(`${base}/timespentonpractice?student=${userId}${q}`);
    // ;
    await status.fetchData(`${base}/questionAttemptStatus?student=${userId}${q}`);
    await difficulty.fetchData(`${base}/questiondifficultystatus?student=${userId}${q}`);
    await cognitive.fetchData(`${base}/questioncognitivestatus?student=${userId}${q}`);
  };

  useEffect(() => {
    loadAnalytics();
  }, [filterData]);

  return {
    practice,
    learning,
    progress,
    time,
    status,
    statusPie,
    difficulty,
    cognitive
  };
}